<template>
  <div style="height:100%; width: 100%">
    <app-header />
    <main class="page-container">
      <movie-quiz />
    </main>
  </div>
</template>

<script>
import AppHeader from "../../components/AppHeader.vue";
import MovieQuiz from "../../components/MovieQuiz.vue";
import firebase from "firebase";

export default {
  name: "MovieQuizPage",
  components: {
    AppHeader,
    MovieQuiz
  },
  mounted() {
    firebase
      .database()
      .ref()
      .child("visitor")
      .once("value", sn => {
        firebase
          .database()
          .ref()
          .child("visitor")
          .update({
            value: sn.val().value + 1
          });
      });
  }
};
</script>
